import makeStyles from '@material-ui/core/styles/makeStyles'
import { CancelButton, reExportedColors, NextButton, Text } from '../../1elements'
import { validateClientSearch, validateLocationSearch } from '../../../services/util/editChecks'
import ButtonLayoutDiv from '../../4layout/ButtonLayoutDiv'
import ClientSearch from './ClientSearch'
import LocationSearchByEndCustomerName from './LocationSearchByEndCustomerName'

const ServicesTab = ({selectedLocation, setSelectedLocation, onNextService, onCancel, showError, disabled, selectedClient,
  setSelectedClient}) => {
    const classes = useStyles()
    const selectedClientName = selectedClient && selectedClient.end_customer_name

    return(
        <div className={classes.root}>
            <Text type={'tabHeadingSecondary'}>Add services to an existing location</Text>
            <div className={classes.formDiv}>
              <Text type={'fieldLabel'}>Client Name<span className={'requiredAsterisk'} >*</span></Text>
              <ClientSearch selectedClient={selectedClient} setSelectedClient={setSelectedClient}
                            validation={showError&&validateClientSearch(selectedClient)} disabled={disabled}/>
            </div>
            <div className={classes.formDiv}>
              <Text type={'fieldLabel'}>Location Name<span className={'requiredAsterisk'} >*</span></Text>
              <LocationSearchByEndCustomerName selectedLocation={selectedLocation} setSelectedLocation={setSelectedLocation}
                                               validation={showError&&validateLocationSearch(selectedLocation)} disabled={disabled||!selectedClient}
                                               endCustomerName={selectedClientName} />
            </div>

            <ButtonLayoutDiv>
                {onCancel && <CancelButton onClick={onCancel} /> }
                <NextButton onClick={() => onNextService('Location')} />
            </ButtonLayoutDiv>

        </div>
    )
}

const useStyles = makeStyles({
    root: {
        padding: '20px'
    },
    formDiv: {
        margin: '20px 0'
    },
    optionItem: {
        alignItems: 'center',
        cursor: 'pointer',
        display: 'flex',
        marginBottom: '20px',

        '&:hover': {
            backgroundColor: reExportedColors.LIGHT_GREY ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
        }
    },
})

export default ServicesTab